module.exports = __webpack_public_path__ + "static/img/对号-初始_icon_svg.bb2ee85d.svg";